export default {"src":"https://s.sylndr.com/c-c51c782/_next/static/media/arrowHead.a01ed1ad.svg","height":6,"width":8,"blurWidth":0,"blurHeight":0};